import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { server } from "../server";


const ActivationPage = () => {
  const { activation_token } = useParams();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Your token has expired!");
  const [successMessage, setSuccessMessage] = useState("Your account has been created successfully!");
  const [activatedUser, setActivatedUser] = useState(null);
  const [resendIdentifier, setResendIdentifier] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [isResending, setIsResending] = useState(false);
  const activationAttemptedRef = useRef("");

  useEffect(() => {
    if (activation_token && activationAttemptedRef.current !== activation_token) {
      activationAttemptedRef.current = activation_token;
      const sendRequest = async () => {
        try {
          const response = await axios.post(`${server}/user/activation`, {
            activation_token,
          });

          setSuccessMessage(
            response.data?.message || "Your account has been created successfully!"
          );
          setActivatedUser(response.data?.user || null);
        } catch (err) {
          setError(true);
          setErrorMessage(err.response?.data?.message || "Your token has expired!");
        }
      };
      sendRequest();
    }
  }, [activation_token]);

  const handleResendActivation = async (event) => {
    event.preventDefault();

    if (!resendIdentifier.trim()) {
      setResendMessage("Enter your email, handle, or unique ID to resend verification.");
      return;
    }

    setIsResending(true);
    setResendMessage("");

    try {
      const response = await axios.post(`${server}/user/activation/resend`, {
        identifier: resendIdentifier.trim(),
        email: resendIdentifier.trim(),
      });
      setResendMessage(response.data?.message || "If this account exists, a new activation link has been sent.");
    } catch (err) {
      setResendMessage(err.response?.data?.message || "Unable to resend verification right now.");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="activation-page">
      {error ? (
        <div className="activation-message-card">
          <p>{errorMessage}</p>
          <p>This verification link may have already been used. You can sign in or request a new verification email.</p>
          <form className="activation-resend-form" onSubmit={handleResendActivation}>
            <input
              type="text"
              value={resendIdentifier}
              onChange={(event) => setResendIdentifier(event.target.value)}
              placeholder="Email, handle, or unique ID"
              className="activation-resend-input"
            />
            <button type="submit" className="activation-signin-button" disabled={isResending}>
              {isResending ? "Sending..." : "Resend Verification"}
            </button>
          </form>
          {resendMessage ? <p>{resendMessage}</p> : null}
          <Link to="/login">
            <button className="activation-signin-button">
              Sign In
            </button>
          </Link>
        </div>
      ) : (
        <>
          <p>{successMessage}</p>
          {activatedUser?.uniqueId ? (
            <div style={{ margin: "1.5rem auto", maxWidth: "22rem", textAlign: "center" }}>
              <p>
                <strong>Unique ID:</strong> {activatedUser.uniqueId}
              </p>
              {activatedUser.qrCodeUrl ? (
                <img
                  src={activatedUser.qrCodeUrl}
                  alt="Your MATRIX QR code"
                  style={{ width: "220px", height: "220px", objectFit: "contain", margin: "1rem auto" }}
                />
              ) : null}
              {activatedUser.qrCodeTargetUrl ? (
                <p>
                  <a href={activatedUser.qrCodeTargetUrl}>Open your public profile</a>
                </p>
              ) : null}
            </div>
          ) : null}
          <Link to="/login">
            <button className="activation-signin-button">
              Sign In
            </button>
          </Link>
        </>
      )}
    </div>
  );
};

export default ActivationPage;
